// import React, { useEffect, useState } from "react";
// import axios from "axios";

// const FAQContent = () => {
//   const [data, setData] = useState(null);

//   useEffect(() => {
//     axios.get("http://localhost:5000/api/site-content/bottom-keydata") // replace with your actual endpoint
//       .then(response => {
//         setData(response.data);
//       })
//       .catch(error => {
//         console.error("Error fetching FAQ content:", error);
//       });
//   }, []);

//  if (!data) {
//   return (
//     <div className="spinner-container">
//       <div className="spinner"></div>
//     </div>
//   );
// }

//   return (
//     <div className="faq-container">
//       <div
//         className="faq-content"
//         dangerouslySetInnerHTML={{ __html: data.content }}
//       ></div>
//     </div>
//   );
// };

// export default FAQContent;






import React, { useEffect, useState } from "react";
import axios from "axios";
import "./FAQContent.css"; // Import custom styles

const FAQContent = () => {
  const [data, setData] = useState(null);

  // useEffect(() => {
  //   axios.get("http://localhost:5000/api/site-content/bottom-keydata")
  //     .then(response => {
  //       setData(response.data);
  //     })
  //     .catch(error => {
  //       console.error("Error fetching FAQ content:", error);
  //     });
  // }, []);

  useEffect(() => {
  axios
    .get(`${process.env.REACT_APP_NODE_BACKEND_API_URL}/site-content/bottom-keydata`)
    .then(response => {
      setData(response.data);
    })
    .catch(error => {
      console.error("Error fetching FAQ content:", error);
    });
}, []);



  if (!data) {
    return (
      <div className="faq-loader">
        <div className="faq-spinner"></div>
      </div>
    );
  }

  return (
    <div className="faq-wrapper">
      <div className="faq-box">
        <h2 className="faq-title">{data.title}</h2>
        <div
          className="faq-content"
          dangerouslySetInnerHTML={{ __html: data.content }}
        ></div>
      </div>
    </div>
  );
};

export default FAQContent;







